import React from "react";
import { HomeCarousel } from "../components/HomeCarousel";
import "../components/components.css";
import { Banner } from "../components/Banner";
import { About } from "../components/About";
import { Affiliations } from "../components/Affiliations";
// import { ProductPage } from '../components/ProductPage'
// import Testimonials from '../components/Testimonials'
import { Contact } from "../components/Contact";
import { ProductCarousel } from "../components/ProductCarousel";
import { Whyus } from "../components/Whyus";
import { Certifications } from "./Certifications";
import { ProductPage } from "../components/ProductPage";
import { Certificate } from "./Certificate";
import { Contacts } from "./Contacts";

// import { OurServices } from '../components/OurServices'
// import { ProductCardCarousel } from '../components/ProductCardCarousel'
// import { OurProducts } from '../components/OurProducts'

export const Home = () => {
  return (
    <>
      <HomeCarousel />
      {/* <Banner /> */}
      <ProductPage />
      {/* <OurProducts /> */}
      {/* <OurServices /> */}
      {/* <ProductCarousel /> */}
      <Whyus />
      <About />
      {/* <Certifications /> */}
      <Certificate />
      <Affiliations />
      {/* <Contacts /> */}
      {/* <ProductCardCarousel /> */}
      {/* <Testimonials /> */}
      <Contact />
    </>
  );
};
